import { Routes } from '@angular/router';
import { Auth } from './auth/auth';
import { sessionGuard } from './services/security/session.guard';

export const routes: Routes = [
    {
        path: 'login',
        loadComponent: () => Auth
    },
    {
        path: '',
        canActivate: [sessionGuard],
        loadComponent: () => import('./pages/slots-app').then(m => m.SlotsApp),
        loadChildren: () => import('./pages/slots-app.routes').then(m => m.routes)
    },
    {
        path: '**',
        redirectTo: 'login'
    }
];
